import { Stack, styled, useMedia, YStack } from 'tamagui';
import { LinkCore, LinkCoreProps } from 'solito/link';
import { Anchor } from 'tamagui';
import React, { useEffect, useState, useRef } from 'react';
import { Animated } from 'react-native';
export const Center = styled(Stack, {
  name: 'Center',
  alignItems: 'center',
  justifyContent: 'center'
});
export const Flex = styled(Stack, {
  name: 'Flex',
  display: 'flex'
});
export const HiddenNew = ({
  children,
  from,
  till
}) => {
  const media = useMedia();
  function isVisible(from, till) {
    let visible = false;
    let foundFrom = false;
    const mediaArray = Object.entries(media);
    for (let i = 0; i < mediaArray.length; i++) {
      const [size, isVisible] = mediaArray[i];
      if (size === from) {
        foundFrom = true;
      }
      if (foundFrom && !isVisible) {
        visible = true;
      }
      if (size === till) {
        break;
      }
    }
    return visible;
  }
  if (isVisible(from, till)) {
    return null; // Hide the component
  } else {
    return {
      children
    };
  }
};

// Fine for now, but we need to figure out a more generalizable way eventually - but this works for all extant use cases
export const Hidden = ({
  children
}) => {
  return /*#__PURE__*/React.createElement(Stack, {
    $base: {
      display: 'none'
    },
    $sm: {
      display: 'none'
    },
    $md: {
      display: 'initial'
    }
  }, children);
};
const StyledTextLink = styled(Anchor, {
  name: 'TextLink'
});

// TODO does NOT do _blank external linking. Find a workaround
export const Link = StyledTextLink.styleable(({
  children,
  href,
  isExternal,
  ...restProps
}, ref) => {
  const target = isExternal ? '_blank' : undefined;
  return /*#__PURE__*/React.createElement(LinkCore, {
    style: {
      textDecoration: 'none'
    },
    Component: StyledTextLink,
    componentProps: restProps,
    href: href,
    ref: ref,
    target: target
  }, children);
});
export const ShadowCard = styled(Stack, {
  name: 'ShadowCard',
  boxShadow: 'rgba(0, 0, 0, 0.25) 0px 2px 3.84px'
});
export const Collapsible = ({
  collapsed,
  children
}) => {
  const [height, setHeight] = useState(0);
  const [measured, setMeasured] = useState(false);
  const animatedHeight = useRef(new Animated.Value(collapsed ? 0 : 1)).current;
  useEffect(() => {
    if (measured) {
      Animated.timing(animatedHeight, {
        toValue: collapsed ? 0 : 1,
        duration: 300,
        useNativeDriver: false
      }).start();
    }
  }, [collapsed, animatedHeight, measured]);
  const handleLayout = event => {
    const contentHeight = event.nativeEvent.layout.height;
    if (contentHeight > 0 && !measured) {
      setHeight(contentHeight);
      setMeasured(true);
    }
  };
  if (!measured) {
    return /*#__PURE__*/React.createElement(YStack, {
      opacity: 0,
      onLayout: handleLayout
    }, children);
  }
  return /*#__PURE__*/React.createElement(Stack, {
    overflow: "hidden"
  }, /*#__PURE__*/React.createElement(Animated.View, {
    style: {
      height: animatedHeight.interpolate({
        inputRange: [0, 1],
        outputRange: [0, height]
      })
    }
  }, /*#__PURE__*/React.createElement(YStack, {
    bgcolor: "orange",
    width: "100%"
  }, children)));
};